import {Injectable} from '@angular/core';
import {BaseDaoService, RefModelStoreService} from '@q9elements/ui-kit/common';

import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {AssistantType} from '../models/assistant.interface';
import {HistoryItem} from '../models/history.interface';

@Injectable({providedIn: 'root'})
export class AiChatDaoService extends BaseDaoService {
  constructor(private readonly rmeStore: RefModelStoreService) {
    super();
    this.apiUrl = `${this.apiUrl}/chat-ai`;
  }

  public startChat(payload: {message: string; assistantType: AssistantType}) {
    const url = `${this.apiUrl}/refModel/${this.rmeStore.refModel._id}/message`;

    return this.http.post<any>(url, payload).pipe(this.catchAndFormatError()) as Observable<{
      conversationId: string;
      conversationRef: string;
    }>;
  }

  public addMessageToChat(chatId: string, message: string) {
    const url = `${this.apiUrl}/${chatId}/message`;
    const payload = {message};

    return this.http.post<any>(url, payload).pipe(this.catchAndFormatError());
  }

  public regenerateChat(chatId: string) {
    const url = `${this.apiUrl}/${chatId}/regenerate`;

    return this.http.get<any>(url).pipe(this.catchAndFormatError());
  }

  public cancelRunningChat(chatId: string) {
    const url = `${this.apiUrl}/${chatId}/finish`;

    return this.http.get<any>(url).pipe(this.catchAndFormatError());
  }

  public getFileContent(fileId: string, chatId: string) {
    const url = `${this.apiUrl}/${chatId}/file/${fileId}/content`;

    return this.http.get(url, {responseType: 'blob'} as any) as Observable<Blob & ArrayBuffer>;
  }

  public getFileMetadata(fileId: string, chatId: string) {
    const url = `${this.apiUrl}/${chatId}/file/${fileId}/metadata`;

    return this.http.get(url).pipe(this.catchAndFormatError()) as Observable<any>;
  }

  public getHistory() {
    const url = `${this.apiUrl}/refModel/${this.rmeStore.refModel._id}/history`;

    return this.http.get(url).pipe(this.catchAndFormatError()) as Observable<HistoryItem[]>;
  }

  public loadChat(chatId: string) {
    const url = `${this.apiUrl}/${chatId}/load`;

    return this.http.get(url).pipe(this.catchAndFormatError());
  }

  public deleteChat(chatId: string) {
    const url = `${this.apiUrl}/${chatId}`;

    return this.http.delete(url).pipe(this.catchAndFormatError());
  }

  private catchAndFormatError(defaultError?: string) {
    return catchError(response => {
      const result = response.error;
      const msg = result.error || result.message || result._message || defaultError || 'Error';

      return throwError(msg);
    });
  }
}
